import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Mail, Lock } from 'lucide-react';

const AuthPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      toast.success('Logged in successfully!');
      navigate('/dashboard');
    } else {
      toast.error(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-[0_8px_24px_rgba(0,0,0,0.08)] border border-slate-200">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold tracking-tight text-slate-900 mb-2">LeadSync AI</h1>
          <p className="text-sm leading-relaxed text-slate-600">
            Sign in to your account
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label htmlFor="email" className="text-slate-900">Email</Label>
            <div className="relative mt-1.5">
              <Mail className="absolute left-3 top-3 h-5 w-5 text-slate-400" />
              <Input
                data-testid="auth-email-input"
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="pl-10 rounded-lg border-slate-200 focus:ring-2 focus:ring-slate-900/10 focus:border-slate-900"
                placeholder="you@example.com"
                required
              />
            </div>
          </div>

          <div>
            <Label htmlFor="password" className="text-slate-900">Password</Label>
            <div className="relative mt-1.5">
              <Lock className="absolute left-3 top-3 h-5 w-5 text-slate-400" />
              <Input
                data-testid="auth-password-input"
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pl-10 rounded-lg border-slate-200 focus:ring-2 focus:ring-slate-900/10 focus:border-slate-900"
                placeholder="••••••••"
                required
              />
            </div>
          </div>

          <Button
            data-testid="auth-submit-button"
            type="submit"
            className="w-full rounded-lg font-medium transition-all active:scale-95 bg-slate-900 hover:bg-slate-800 text-white"
            disabled={loading}
          >
            {loading ? 'Please wait...' : 'Sign In'}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <p className="text-sm text-slate-600">
            Contact your administrator to get access
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
